import { createAction, createActionWithPayload } from './helpers';

export const setRegistrationDone = () => createAction('@registration/SET_REGISTRATION_DONE');

export const setNotVerified = (payload: boolean) =>
  createActionWithPayload('@registration/SET_NOT_VERIFIED', payload);

export type RegistrationActions = ReturnType<typeof setRegistrationDone | typeof setNotVerified>;
